import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@env/environment';
import { feedback } from '@/common/sentry/feedback';
import { isStaleChunkReloadError } from '@/common/router/reload-on-stale-chunk';

if ('local' !== environment.sentryENV) {
	console.log('Initializing Sentry');
	Sentry.init({
		environment: environment.sentryENV,
		release: environment.releaseSHA,
		dsn: environment.sentryDSN,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
			feedback
		],
		replaysSessionSampleRate: 0.5,
		replaysOnErrorSampleRate: 1.0,
		tracesSampleRate: 0.5,
		tracePropagationTargets: [
			'crowdfavorite.technology'
		],
		// A tab left open across a deploy reloads itself when a lazy chunk is gone; don't report that chunk error
		beforeSend: (event, hint) => isStaleChunkReloadError(hint.originalException) ? null : event,
	});
}
bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
	.catch((err) => console.error(err));
